import React from 'react';
import { FaPlay } from 'react-icons/fa';
import '../../../../assets/css/user/about/companyIntro/CompanyIntro.css';
import energeticaboutcompanyImg from '../../../../assets/images/home/energeticaboutcompany.jpg';
const CompanyIntro = () => {
  return (
    <section className="company-intro">
      <div className="container">
        <div className="row align-items-center">
          
          
          <div className="col-lg-6">
            <h2 className="section-heading">WE ARE SMARTAGRI RENT</h2>
            <p className="section-text">
             We are a dedicated agricultural equipment rental and maintenance platform committed to supporting farmers with reliable, modern, and well-maintained machinery. Our goal is to make farming easier, faster, and more productive by providing trusted equipment and professional maintenance services under one platform.
            </p>
            
            {/* <div className="video-button">
              <div className="play-icon">
                <FaPlay />
              </div>
              <div className="video-text">
                <div>Watch SmartAgri Rent Tour  </div>
                <div className="video-duration">Learn how our rental and maintenance system supports modern farming</div>
              </div>
            </div> */}
          </div>

          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="intro-image-wrapper">
              <div className="yellow-shape"></div>
              <img 
                src= {energeticaboutcompanyImg}
                alt="Agricultural Equipment"
                className="intro-image"
              />
            </div>
          </div>
        </div>
      </div>
      
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
    </section>
  );
};

export default CompanyIntro;